import Vue from 'vue';
import template from './index.html';

// todo update to final video when done
const videoWidth = 1920;
const videoHeight = 1080;

export default Vue.extend({
  name: 'BgVideo',
  template,
  data: () => ({
    style: {
      width: videoWidth,
      height: videoHeight,
      top: 0,
      left: 0,
    },
  }),
  methods: {
    handleResize() {
      // resize the video to always fit in the parent
      const { clientHeight, clientWidth } = this.$parent.$el;

      const containerW = clientWidth;
      const containerH = clientHeight;
      const containerR = containerW / containerH;

      // get video size
      const videoW = parseInt(videoWidth, 10);
      const videoH = parseInt(videoHeight, 10);
      const videoR = videoW / videoH;

      // calculate proportions
      let vidW = 0;
      let vidH = 0;
      let vidT = 0;
      let vidL = 0;

      if (containerR > videoR) { // width = container with
        vidW = containerW;
        vidH = containerW / videoR;
        vidT = -Math.round((vidH - containerH) / 2);
        vidL = 0;
      } else { // height = containerheight
        vidW = containerH * videoR;
        vidH = containerH;
        vidT = 0;
        vidL = -Math.round((vidW - containerW) / 2);
      }

      this.style = {
        width: `${vidW}px`,
        height: `${vidH}px`,
        top: `${vidT}px`,
        left: `${vidL}px`,
      };
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);

    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

});



// WEBPACK FOOTER //
// ./src/js/components/bg-video/index.js